import EventEmitter from "./EventEmitter";

class AudioEffects extends EventEmitter {
  constructor() {
    super();
    this._mute = false;
    // this.context = new AudioContext();
    console.log("AUDIO EFFECTS");
    // this.loadDefaultAudios();
  }

  set mute(value) {
    this._mute = value;
  }
  get mute() {
    return this._mute;
  }

  start() {
    this.loadDefaultAudios();
  }

  async loadDefaultAudios() {
    this.data = [];
    for (let i = 1; i <= 10; i++) {
      // add leading zero
      let num = i.toString().padStart(2, "0");
      this.data.push(new Audio(`./sound/pops_${num}.mp3`));
    }

    // add progress sounds
    this.progress = [];
    for (let i = 1; i <= 5; i++) {
      //  let num = i.toString().padStart(2, "0");
      this.progress.push(new Audio(`./sound/progress/${i}.mp3`));
    }

    // add falling sound
    this.falling = await this.loadSingleAudio("./sound/falling.mp3");
    // add wining sound
    this.winning = await this.loadSingleAudio("./sound/win/15.mp3");
    // add error sound
    this.error = await this.loadSingleAudio("./sound/error/2.mp3");
    // add gameover sound
    this.gameover = await this.loadSingleAudio("./sound/gameover/5.mp3");

    this.sounds = {
      falling: this.falling,
      winning: this.winning,
      error: this.error,
      gameover: this.gameover,
    };

    this.emit("ready", []);
    console.log("READY FROM CLASS");
  }

  play(name) {
    if (!this._mute) {
      this.sounds[name].currentTime = 0;
      // this.context.resume().then(() => {
      this.sounds[name].play();
      // });
    }
  }

  loadSingleAudio(url) {
    return new Promise((resolve, reject) => {
      const audio = new Audio(url);
      audio.playsinline = true;
      audio.addEventListener("canplaythrough", () => {
        resolve(audio);
      });
      audio.load();
    });
  }

  playRandom(offset = 0) {
    let _audio = Math.floor(Math.random() * this.data.length);
    while (_audio == this.previousAudio) {
      _audio = Math.floor(Math.random() * this.data.length);
    }
    this.previousAudio = _audio;
    setTimeout(() => {
      if (!this._mute) {
        // this.context.resume().then(() => {
        this.data[_audio].play();
        // });
      }
    }, offset);
  }

  playRandomProgress(offset = 0) {
    let _audio = Math.floor(Math.random() * this.progress.length);
    while (_audio == this.previousAudioProgress) {
      _audio = Math.floor(Math.random() * this.progress.length);
    }
    this.previousAudioProgress = _audio;
    setTimeout(() => {
      if (!this._mute) {
        // this.context.resume().then(() => {
        this.progress[_audio].play();
        // });
      }
    }, offset);
  }

  // playError(offset = 0) {
  //   setTimeout(() => {
  //     // this.error.set
  //     this.error.play();
  //   }, offset);
  // }

  playIndex(index, offset = 0) {
    this.previousAudio = index;
    setTimeout(() => {
      if (!this._mute) {
        // this.context.resume().then(() => {
        this.data[index].play();
        // });
      }
    }, offset);
  }

  resume() {
    // this.context.resume();
  }
}

export default new AudioEffects();
